import { render, staticRenderFns } from "./PlayerTitle.vue?vue&type=template&id=d78d3306&scoped=true&"
import script from "./PlayerTitle.vue?vue&type=script&lang=js&"
export * from "./PlayerTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78d3306",
  null
  
)

export default component.exports